<template>
  <div class="zoneWrapper">


    <div class="card padtop">
      <!-- <div class="col-md-6"> -->
        <div class="row">
          <div class="col-md-2">
            <h5 class="card-title">Zona</h5>
            
              <el-select 
                          
                          v-model="zonaElegida"
                          placeholder="Elija una Zona">
                <el-option v-for="zona in zonas"
                            
                            :value="zona.zona_id"
                            :label="zona.zona_nombre"
                            :key="zona.zona_id">
                </el-option>
              </el-select>
            
          </div>

          <div class="col-md-2">
            <h5 class="card-title">Criterio</h5>
            
              <el-select 
              
                          size="large"
                          v-model="criterioElegido"
                          placeholder="Criterio">
                <el-option v-for="criterio in criterios"
                            
                            :value="criterio.value"
                            :label="criterio.label"
                            :key="criterio.label">
                </el-option>
              </el-select>
            
          </div>

          <div class="datePick col-md-4">
            <h4 class="card-title ">Rango</h4>
            <div class="form-group">
              <el-date-picker 
                              v-model="daterange"
                              type="daterange"
                              placeholder="Seleccione un día"
                              to="a"
                              format="dd/MM/yyyy"
                              @change = "RangeSelected()"
                              >
              </el-date-picker>
            </div>
            <div class="result">
                <p v-if="this.differenceInDays > 7" >Seleccione a lo sumo un rango de 7 dias</p>
            </div>
          </div>

            <div class="col-md-2">
                <p-button
                :disabled="false ? true: this.differenceInDays > 7"
                class="form-buttons report-buttons"
                type="neutral"
                round
                @click="insertQuery()"
                > <i class="nc-icon nc-refresh-69" style="font-size: 2.5em;"></i>
                    <p style=" padding-top: 15px; margin-bottom: 0px; font-size: 1.3em;">Generar</p>
                </p-button>
            </div>

        </div>
      <!-- </div> -->
    </div>



    <div class="col-md-12 card">
      <div class="card-header">
          <h3 class="title-report">Estado de las consultas ingresadas</h3>
      </div>
      <div class="card-content row">
        <div class="col-sm-2">
          <el-select
            class="select-default"
            size="small"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-10">
          <div class="pull-right">
            <label>
              <input type="search" class="form-control input-sm" placeholder="Búsqueda" v-model="searchQuery" aria-controls="datatables">
            </label>
          </div>
        </div>
        <div class="col-sm-12">
          <el-table stripe
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column  v-for="column in tableColumns"
                            :key="column.label"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :formatter="column.formatter"
                            :label="column.label">
            </el-table-column>
            <el-table-column
              :min-width="100"
              fixed="right"
              label="Acción">
              <template slot-scope="props">
                <a class="btn btn-md btn-neutral btn-icon btn-round" @click="showQueryDetail(props.$index, props.row, props)"><i class="nc-icon nc-zoom-split"></i></a>
                <!--<a class="btn btn-lg btn-danger btn-icon remove"  @click="handleDelete(props.$index, props.row)"><i class="ti-close"></i></a>-->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <br>
          <p class="category">Mostrando {{from + 1}} a {{to}} de {{total}} consultas</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>


    <div id="queryDetail" class="card">
      <div class="card-header" v-if="this.detailQuery.id">
          <h3 class="title-report">Detalle de la consulta. Id: {{detailQuery.id}} Zona: {{detailQuery.zona}} </h3>
      </div>

      <div class="card-content table-responsive table-full-width" style="overflow: hidden;">

        <el-table stripe :data="tableData" @row-click="rowClick">

          <el-table-column label="Id"><template slot-scope="scope">
              {{scope.row.id}}
          </template></el-table-column>
          <el-table-column label="Vehículo"><template slot-scope="scope">
              {{scope.row.veh_id}}
          </template></el-table-column>
          <el-table-column label="Fecha Desde"><template slot-scope="scope">
              {{scope.row.zona_rep_item_fecha_desde}}
          </template></el-table-column>
          <el-table-column label="Fecha Hasta"><template slot-scope="scope">
              {{scope.row.zona_rep_item_fecha_hasta}}
          </template></el-table-column>
          <el-table-column label="Ubicación"><template slot-scope="scope">
              {{scope.row.zona_rep_item_ubicacion}}
          </template></el-table-column>
        </el-table>

        <div class="card-footer">
          <h3 class="title-report"></h3>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {DatePicker, Button, Select, Option, Table, TableColumn} from 'element-ui'
import axios from 'axios'
import {ConfigParams} from '../../../config'
import PPagination from '../../UIComponents/Pagination'
import zonaService from '../../../services/zonas'
import swal from 'sweetalert2'
import {EventBus} from '../../../../src/eventBus'
import Vue from 'vue'
//import ZonaResumen from './ZonaResumen.vue'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)

export default {

  components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker,
      PPagination


    },
  data(){
    return{
      hasError: '',
      differenceInDays: '',
      daterange: '',
      zonas: [],
      zonaElegida: '',
        criterios:[
          {value: 'DENTRO', label: 'DENTRO'},
          {value: 'FUERA', label: 'FUERA'},
          {value: 'TODOS', label: 'TODOS'}
        ],
        criterioElegido: '',
        pickerOptions1: {
          shortcuts: [{
            text: 'Today',
            onClick (picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: 'Yesterday',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: 'A week ago',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        },
        fechadesde: '',
        fechahasta: '',
        queryId: '',

        // nuevadata -->
        tableData: [],
        selected: '',
        zonaId: '',
        criterio: '',
        fechaDesde: '',
        fechaHasta: '',
        detailQuery: {},
        alerts: [],
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        tableColumns: [
          {
            prop: 'id',
            label: 'Id',
            minWidth: 50
          },
          {
            prop: 'zona_query_fecha_carga',
            label: 'Fecha de Carga',
            minWidth: 180
          },
          {
            prop: 'zona_query_fecha_desde',
            label: 'Desde',
            formatter: (row, col, cell, index) => this.addressFormatter(cell),
            minWidth: 180
          },
          {
            prop: 'zona_query_fecha_hasta',
            label: 'Hasta',
            formatter: (row, col, cell, index) => this.addressFormatter(cell),
            minWidth: 180
          },
          {
            prop: 'zona_id.zona_nombre',
            label: 'Zona',
            minWidth: 180
          },
          {
            prop: 'zona_query_busqueda',
            label: 'Búsqueda',
            minWidth: 100
          },
          {
            prop: 'zona_query_state',
            label: 'Estado',
            minWidth: 100
          }
        ]
    }
  },
  computed: {
      pagedData () {
        return this.alerts.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.alerts.length      /* Si el campo search esta vacío muestra todas filas */
          return this.pagedData
        }
        let result = this.alerts.filter((row) => {
          return row.zona_query_state.match(this.searchQuery) || row.zona_query_busqueda.match(this.searchQuery) || row.zona_query_fecha_carga.match(this.searchQuery)
        })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.alerts.length
        return this.alerts.length
      }
    },
  methods: {
     selectZonaId (zonaNombre) {
      for (var i = 0; i < this.zona.length; i++) {
        if (this.zona[i].zona_nombre === zonaNombre) {
          return this.zona[i].cli_id
        }
      }
      return null
    },
    getZonas () {
		zonaService.index().then(res=>{
        this.zonas = res.data
            })
    },
    insertQuery () {

      let desde = this.formatDate(this.daterange[0])
      let hasta = this.formatDate(this.daterange[1])
        zonaService.zonaput(this.zonaElegida,this.criterioElegido, desde, hasta).then(res=>{

          console.log(res)
          this.queryId = res.data.last_insert_id
          let urlxls = ConfigParams.API_REP_URL + 'zone.php?qid=' + this.queryId
          urlxls += '&xval=' + ConfigParams.INDEX_KEY
          console.log("console urlxls:" + urlxls)


          // window.open(urlxls, '_blank')
          axios.get(urlxls)
          swal({
            title: 'Consulta enviada',
            text: 'Por favor espere unos minutos hasta que se termine de procesar',
            timer: 3000,
            showConfirmButton: false
          })
          this.getData()
          this.startPeriodicQuery()
        })
        .catch(
            (error) => console.log(error)
        )
    },
    formatDate2(fecha){
      let newdate = new Date(fecha)
      return newdate.toISOString().substring(0,10)
    },
    recibida(){
      swal({
      title: `Aviso`,
      text: 'Consulta procesada con exito!',
      buttonsStyling: false,
      confirmButtonClass: 'btn btn-success btn-fill',
      type: 'success'
      })
    },
    formatDate (actualDate) {
      var newdate = new Date(actualDate)
      var month = newdate.getMonth() + 1// months from 1-12
      var day = newdate.getDate()
      var year = newdate.getFullYear()

      newdate = year + '-' + month + '-' + day
      return newdate
    },
    getData () {
        zonaService.getData().then(res=>{
            this.alerts = res.data
        }).catch((error) => console.log(error))
    },
    startPeriodicQuery () {
      var self = this
      this.interval = setInterval(function () {
        self.checkQueryState(self.queryId)
      }, 5000)
    },
    checkQueryState (id) {
      zonaService.checkQueryState(id).then(res=>{
        console.log(res)
          if (res.data[0].zona_query_state === 'LISTO') {
            clearInterval(this.interval)
            swal({
              title: `Aviso`,
              text: 'Consulta procesada con exito!',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'success'
            })
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
          //clearInterval(this.interval)
        })

    },

    rowClick (row) {
        this.$router.push('/itemTimeLine/' + row.veh_id + '/' + row.log_rep_id)
      },
      addressFormatter (cell) {
        return cell.substring(0, 10)
      },
      //
      showQueryDetail (index, row) {
        this.tableData = []
        zonaService.showQueryDetail(index, row).then(res=>{
            console.log("dentro de ShowQueryDetail: ", res)
            this.tableData = res.data
            this.detailQuery.id = row.id
            this.detailQuery.zona = row.zona_id.zona_nombre
            setTimeout(() => {
                let elmnt = document.getElementById('queryDetail');
                elmnt.scrollIntoView(false);
            }, 100)
            // window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);

          }
          )
          .catch(
          (error) => console.log(error)
          )
      },

        getData () {
        zonaService.getData().then(res=>{
            this.alerts = res.data
        }).catch((error) => console.log(error))
        },


      startPeriodicQuery () {
        let self = this
        this.interval = setInterval(function () {
          self.checkQueryState(self.queryId)
        }, 5000)
      },

      checkQueryState (id) {
          zonaService.checkQueryState(id).then(res=>{
            if (res.data[0].zona_query_state === 'LISTO') {
              clearInterval(this.interval)
              swal({
                title: `Aviso`,
                text: 'Consulta procesada con exito!',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-success btn-fill',
                type: 'success'
              })
              this.getData()
            }
          })
          .catch(
          (error) => {
            console.log(error)
            clearInterval(this.interval)
          })
      },

      handleResize() {
        // document.getElementById("content").style.height = "100%";
        let navbarHeight = document.getElementById("navbar").offsetHeight;
        let windowHeight = window.innerHeight;
        let contentHeight = windowHeight - navbarHeight;
        document.getElementById("content").style.height = contentHeight + "px";
      },
        RangeSelected(){
    

    // To calculate the time difference of two dates 
    let Difference_In_Time = this.daterange[0].getTime() - this.daterange[1].getTime(); 
  
    // To calculate the no. of days between two dates 
    this.differenceInDays = (Difference_In_Time / (1000 * 3600 * 24))*-1;
    this.hasError = false;
    if(this.differenceInDays > 7){
      this.hasError = true;
    }
    console.log(this.hasError)
    console.log(this.differenceInDays)

  }

  },
  mounted () {
    this.getZonas()
    this.getData()
    this.handleResize()
    window.addEventListener("resize", this.handleResize);

  },
  beforeDestroy () {
    clearInterval(this.interval)
    }
}
</script>


<style scoped>

.extended-forms .el-select {
width: 100%;
}

.datePick {
        margin-top: -35px;
}

.datePick > .result{
  text-align: center;
  position: absolute;
  width: 100%;;
}

.datePick > .result > p{
    color: red;
    margin-bottom: 0px;
}

.datePickBorderError{
  border-color: red !important;

}

.datePickBoderError > input{
  color: red !important;
}

.card .card-content, .card-body {
    padding: 0px 15px 0px 15px;
    box-shadow: 0 6px 10px -4px rgba(40, 40, 40, 0.7);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
}

.padtop {
  padding: 10px;
  box-shadow: 0 6px 10px -4px rgba(40, 40, 40, 0.7) !important;
}

.zoneWrapper {
  padding: 10px;
}

#enviar {
  margin-top: 0px;
}
.el-input > input{
  background:black;
}

.el-select .el-input.is-focus .el-input__inner{
  color: blue;
}

.el-select .el-input:hover .el-input__icon, .el-select .el-input:hover input {
    color: black;
}
</style>
